import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEEG = { verzekeraar: '', klantnummer: '', polisnummer: '' };
const VELDEN = [
  { veld: 'verzekeraar', label: 'Verzekeraar', placeholder: 'bv. Bovemij' },
  { veld: 'klantnummer', label: 'Klantnummer', placeholder: 'bv. 10062241' },
  { veld: 'polisnummer', label: 'Polisnummer', placeholder: 'Nog niet ingesteld' },
];
const uit = (d) => ({ verzekeraar: d?.verzekeraar || '', klantnummer: d?.klantnummer || '', polisnummer: d?.polisnummer || '' });

// R7F: één verzekeringsblok per locatie. Alleen admin wijzigt (4.8a/b), de rest leest.
export const VerzekeringCard = ({ locatieId, isAdmin }) => {
  const [waarden, setWaarden] = useState(LEEG);
  const [origineel, setOrigineel] = useState(LEEG);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!locatieId) return undefined;
    let actief = true;
    axios.get(`${API}/locaties/${locatieId}/verzekering`)
      .then(({ data }) => { if (actief) { setWaarden(uit(data)); setOrigineel(uit(data)); } })
      .catch(() => {});
    return () => { actief = false; };
  }, [locatieId]);

  const gewijzigd = VELDEN.some(({ veld }) => waarden[veld] !== origineel[veld]);
  const opslaan = async () => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/locaties/${locatieId}/verzekering`, waarden);
      setWaarden(uit(data));
      setOrigineel(uit(data));
      // geen parent-refetch: de kaart beheert zijn eigen gegevens (geen lege flits)
      toast.success('Verzekering opgeslagen');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Fout bij opslaan');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card data-testid="verzekering-card">
      <CardHeader><CardTitle>Verzekering</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {VELDEN.map(({ veld, label, placeholder }) => (
            <div key={veld}>
              <Label htmlFor={`verzekering-${veld}`}>{label}</Label>
              {isAdmin ? (
                <Input id={`verzekering-${veld}`} value={waarden[veld]} maxLength={64} placeholder={placeholder}
                  onChange={(e) => setWaarden(p => ({ ...p, [veld]: e.target.value }))}
                  className="mt-1" data-testid={`verzekering-${veld}-input`} />
              ) : (
                <p className="text-sm font-medium text-slate-800 bg-slate-50 rounded px-3 py-2 mt-1 break-all" data-testid={`verzekering-${veld}-readonly`}>
                  {waarden[veld] || <span className="text-slate-400 italic font-normal">Niet ingesteld</span>}
                </p>
              )}
            </div>
          ))}
        </div>
        {isAdmin && gewijzigd && (
          <Button type="button" size="sm" disabled={saving} onClick={opslaan} data-testid="verzekering-save-btn">
            {saving ? 'Opslaan...' : 'Verzekering opslaan'}
          </Button>
        )}
        <p className="text-xs text-slate-400">Deze gegevens komen op elke nieuwe schademelding van deze locatie. Alleen een admin kan ze wijzigen.</p>
      </CardContent>
    </Card>
  );
};
